export default "__VITE_ASSET__CHsG1LiH__"